import { render, staticRenderFns } from "./accessRestriction.vue?vue&type=template&id=2438adc2"
import script from "./accessRestriction.vue?vue&type=script&lang=js"
export * from "./accessRestriction.vue?vue&type=script&lang=js"
import style0 from "../filters.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports